module.exports = __webpack_public_path__ + "img/f50118e.jpg";